<template lang="pug">
  div.stu-header.bg-white
    div.W
      //- router-link.logo.fl(:to='{name: "stuIndex"}')
        img(src='@/assets/image/common/logo.png' alt='logo')
      img#LogoUrl(src='/static/images/jf/logo.png' v-if="isJF" ref='logo' @click='handleHome')
      img#LogoUrl(src='/static/images/logo_jiaoshiyanxun.png' v-else-if="t2s" ref='logo' @click='handleHome')
      img#LogoUrl(:src='logo' v-else ref='logo' @click='handleHome')
      div.stu-header-linkArea.text-ct(v-if='!t2s && !isJF')
        //- a.fr(@click='changeLang') {{$t('header.lang')}}
        //- a.fr.f16(href='/static/page/download.html' target='_blank') {{ $t('header.app') }}
        //- a.fr.f16(href='/static/page/about.html' target='_blank') {{ $t('header.about') }}
      div.stu-header-linkArea.text-ct(v-if='isJF')
        label.fr.f16(@click="go2instructionJF") {{ $t('header.instruction') }}
    div.stu-header-tip.browser-tip(v-if="platform === 'windows' && browser.name !== 'Chrome' && !isJF")
      p {{$t('header.tip_windows')}}
      a(href='https://17ks.chivoxapp.com/guide/360Browse.exe')
        i.icon-360
        | {{$t('header.browser360')}}
      a(href='https://17ks.chivoxapp.com/guide/QQBrowser.exe')
        i.icon-qq
        | {{$t('header.browserqq')}}
      b(@click="platform = ''")
    div.stu-header-tip.browser-tip(v-if="platform === 'mac' && browser.name !== 'Safari'")
      p {{$t('header.tip_mac')}}
      b(@click="platform = ''")
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      t2s: localStorage.getItem('t2s'),
      isJF: this.$store.state.isJF,
      logo: window.ConfigNew.logoUrl('logo.stu.png'),
      platform: this.$util.osCheck(),
      browser: this.$util.browserCheck()
    }
  },
  methods: {
    handleHome() {
      this.$router.push({ name: 'stuIndex' })
    },
    changeLang() {
      if (this.$i18n.locale === 'zh') {
        this.$i18n.locale = 'tw'
      } else {
        this.$i18n.locale = 'zh'
      }
    },
    go2instructionJF() {
      this.$winOpen('/static/page/instructionJF.html')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Stu/header.vue